import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

import { type SchoolYearAndBreakToggle } from '../types'

type Params = {
  status?: SchoolYearAndBreakToggle
}

const useSchoolBreaksCount = (params: Params) =>
  useQuery({
    queryKey: ['panelPeriodsSchoolBreaksListCount', params],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelSchoolBreaksList({
        page_size: 1,
        status: params.status === 'past' ? ['past'] : ['active', 'future'],
        fetchKeys: {
          id: true
        }
      })

      return response.count
    }
  })

export default useSchoolBreaksCount
